import React from "react";
// import { formatDateTime } from "./util";
// import { showDialog } from "../utility";
// import WarningIcon from "@material-ui/icons/Warning";
// import ImageIcon from "@material-ui/icons/Image";
// import { env } from "../../env";

export const numFormatter = (data) => {
  return parseFloat(data).toLocaleString(data, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

export const formatCurrency = (cellContent) => {
  // Jika cellContent adalah null atau undefined, ubah menjadi 0
  if (cellContent === null || cellContent === undefined) {
    cellContent = 0;
  }

  // Format angka menggunakan Intl.NumberFormat
  const formattedCurrency = new Intl.NumberFormat("id-ID", {
    style: "currency",
    currency: "IDR",
    minimumFractionDigits: 2,
  }).format(Math.abs(cellContent));

  // Tambahkan tanda negatif setelah simbol mata uang jika angkanya negatif
  if (cellContent < 0) {
    return `Rp -${formattedCurrency.slice(2)}`;
  }

  return formattedCurrency;
};

export const formatQuantity = (cellContent) => {
  // Jika cellContent adalah null, kembalikan nilai 0
  if (cellContent === null || cellContent === undefined) {
    cellContent = 0;
  }

  // Gunakan Intl.NumberFormat untuk memformat nilai
  return new Intl.NumberFormat("id-ID", {
    minimumFractionDigits: 0,
  }).format(cellContent);
};

export const formatQuantityDecimal = (cellContent) => {
  // Jika cellContent adalah null, kembalikan nilai 0
  if (cellContent === null || cellContent === undefined) {
    cellContent = 0;
  }

  // Gunakan Intl.NumberFormat untuk memformat nilai dengan desimal
  return new Intl.NumberFormat("id-ID", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2, // Mengatur maksimal 2 angka di belakang koma
  }).format(cellContent);
};
export const formatQuantityDecimalFix = (cellContent) => {
  if (cellContent === null || cellContent === undefined) {
    cellContent = 0;
  }

  // Truncate ke 2 digit desimal tanpa pembulatan
  const truncated = Math.floor(cellContent * 100) / 100;

  return truncated.toLocaleString("id-ID", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  });
};

export const formatUsd = (cellContent) => {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2,
  }).format(cellContent);
};

export const formatterVisitStatus = (cellContent) => {
  let style = "";
  if (cellContent === "STARTED") {
    style = "success";
  } else if (cellContent === "NOT STARTED") {
    style = "danger";
  } else style = "warning";

  return (
    <span
      className={`label label-${style} label-inline font-weight-bold py-4  mt-1`}
    >
      {cellContent}
    </span>
  );
};

export const formatterStatus = (cellContent) => {
  let style = "";
  if (cellContent === "CLOSED") {
    style = "success";
  } else if (cellContent === "OPEN") {
    style = "danger";
  } else if (cellContent === "Success") {
    style = "success";
  } else if (cellContent === "Error") {
    style = "danger";
  } else if (cellContent === "NOT STARTED") {
    style = "danger";
  } else if (cellContent === "STARTED") {
    style = "warning";
  } else if (cellContent === "END JOURNEY") {
    style = "success";
  } else if (cellContent === "NEW") {
    style = "danger";
  } else if (cellContent === "IN PROGRESS") {
    style = "warning";
  } else if (cellContent === "RESOLVED") {
    style = "success";
  } else if (cellContent === true) {
    style = "success";
  } else if (cellContent === false) {
    style = "danger";
  } else if (cellContent === "IN RANGE") {
    style = "success";
  } else if (cellContent === "OUT RANGE") {
    style = "danger";
  } else if (cellContent === "SUCCESS") {
    style = "success";
  } else if (cellContent === "FAILED") {
    style = "danger";
  } else if (cellContent === "On Going") {
    style = "info";
  } else if (cellContent === "Finished") {
    style = "success";
  }  else if (cellContent === "CONFIRM") {
    style = "success";
  }  else if (cellContent === "DRAFT") {
    style = "primary";
  }else style = "warning";

  return (
    <span
      className={`label label-${style} label-inline font-weight-bold py-4  mt-1`}
    >
      {cellContent}
    </span>
  );
};

export const formatterVisit = (cellContent) => {
  let style = "";
  if (cellContent === "Visited") {
    style = "success";
  } else if (cellContent === "Pending Visit") {
    style = "danger";
  } else if (cellContent === "Waiting Visit") {
    style = "warning";
  } else style = "warning";

  return (
    <span
      className={`label label-${style} label-inline font-weight-bold py-4  mt-1`}
    >
      {cellContent}
    </span>
  );
};

export const formatterLocation = (cellContent) => {
  let style = "";
  if (cellContent === "PERMANENT") {
    style = "success";
  } else if (cellContent === "Permanent") {
    style = "success";
  } else style = "warning";

  return (
    <span
      className={`label label-${style} label-inline font-weight-bold py-4  mt-1`}
    >
      {cellContent}
    </span>
  );
};

export const formatterType = (cellContent) => {
  let style = "";
  if (cellContent === "CASH") {
    style = "success";
  } else style = "warning";

  return (
    <span
      className={`label label-${style} label-inline font-weight-bold py-4  mt-1`}
    >
      {cellContent}
    </span>
  );
};

export const statusFormatter = (cellContent, row) => {
  let label = "";
  if (cellContent === true) {
    label = "Active";
  } else if (cellContent === false) {
    label = "In Active";
  } else if (cellContent === 1) {
    label = "Yes";
  } else if (cellContent === 0) {
    label = "No";
  }
  let style = "";
  if (cellContent === true) {
    style = "success";
  } else if (cellContent === false) {
    style = "warning";
  } else if (cellContent === 1) {
    style = "success";
  } else if (cellContent === 0) {
    style = "danger";
  }
  return (
    <span
      className={`label label-lg label-${style} label-inline label-width-pending`}
    >
      {label}
    </span>
  );
};

export const YesNoFormatter = (cellContent, row) => {
  let label = "";
  if (cellContent === true) {
    label = "Yes";
  } else if (cellContent === false) {
    label = "No";
  }
  let style = "";
  if (cellContent === true) {
    style = "success";
  } else if (cellContent === false) {
    style = "danger";
  }
  return (
    <span
      className={`label label-lg label-${style} label-inline label-width-pending`}
    >
      {label}
    </span>
  );
};
